import BlockObserver from './BlockObserver';
import Packery from "packery";
import HtmlVideoPlayer from "./HtmlVideoPlayer";

export default class Gallery {
    constructor(el) {
        this.element    = el;
        let urlParams = new URLSearchParams(window.location.search);

        // If gallery ID query param is specified, trigger loadGallery
        if(urlParams.get('gallery')) {
            this.loadGallery(urlParams.get('gallery'), urlParams.get('media'));
        }

        // On click of View Gallery button, trigger loadGallery
        el.addEventListener('click', (e) => {
            e.preventDefault();
            this.loadGallery(el.getAttribute('data-postid'));
        })

        // On click of button to close gallery
        document.body.addEventListener('click', (e) => {
            if(e.target.closest('[closegallery]')) {
                e.preventDefault();
                this.closeGallery();
            }
            if(e.target.closest('.gallery__grid-item')) {
                this.loadLightbox(e.target.closest('.gallery__grid-item').getAttribute('data-id'));
            }
            if(e.target.closest('[closelightbox]')) {
                this.closeLightbox();
            }

            if(e.target.closest('[data-previmage]')) {
                this.loadImageLightbox(e.target.closest('button').getAttribute('data-previmage'));
            }

            if(e.target.closest('[data-nextimage]')) {
                this.loadImageLightbox(e.target.closest('button').getAttribute('data-nextimage'));
            }
        })
    }

    loadGallery(postID, mediaID) {
        this.filters		= new FormData();
        this.filters.append('postID', postID);

        fetch('/wp-admin/admin-ajax.php?action=loadGallery', {
            method: 'POST',
            body: this.filters,
        })
        .then(response => response.json())
        .then(data => {
            if(data) {
                if(document.body.classList.contains('nav--light')) {
                    document.body.classList.remove('nav--light');
                    document.body.classList.add('nav--revert');
                }
                document.body.insertAdjacentHTML('beforeend', data);
            }

            // Update URL with gallery ID
            let pageURL = new URL(window.location.href);
            if(postID) {
                pageURL.searchParams.set('gallery', postID);
                window.history.pushState({}, '', pageURL);
            } else {
                pageURL.searchParams.delete('gallery');
                window.history.pushState({}, '', pageURL);
            }

            // Init Masonry
            let packeryGrid = new Packery('.part-gallery .gallery__grid', {
                itemSelector   : '.gallery__grid-item',
                columnWidth    : '.gallery__grid-item--sizer',
                percentPosition: true,
                gutter         : '.gallery__grid-item--gutter',
            });

            window.app.blockObserver.unmount()
            setTimeout(() => {
                new BlockObserver(document.querySelectorAll('[data-watch="true"]'))
            }, 500);

			if(mediaID) {
				this.loadLightbox(mediaID)
			}

            return data;
        })
    }

    closeGallery() {
        let pageURL = new URL(window.location.href);
        pageURL.searchParams.delete('gallery');
        window.history.pushState({}, '', pageURL);
        document.querySelector('.part-gallery').remove();

        if(document.body.classList.contains('nav--revert')) {
            document.body.classList.remove('nav--revert');
            document.body.classList.add('nav--light');
        }
    }

    loadLightbox(imageID) {
        document.querySelector('.part-gallery-lightbox').classList.add('part-gallery-lightbox--visible');
        this.loadImageLightbox(imageID);
    }

    closeLightbox() {
        document.querySelector('.part-gallery-lightbox').classList.remove('part-gallery-lightbox--visible');

		let pageURL = new URL(window.location.href);
		pageURL.searchParams.delete('media');
		window.history.pushState({}, '', pageURL);
    }

    loadImageLightbox(imageID) {
        document.querySelector('.part-gallery-lightbox .lightbox__content').innerHTML = '';

        let assetToLoad = document.querySelector('.gallery__grid-item[data-id="'+imageID+'"]');
		let allAssets = document.querySelectorAll('.part-gallery .gallery__grid-item');

		allAssets.forEach((asset) => {
			if(asset.getAttribute('data-id') === imageID) {
				let prevAsset = Number(asset.getAttribute('data-count')) - 1;
				let nextAsset = Number(asset.getAttribute('data-count')) + 1;

				if(document.querySelector('.gallery__grid-item[data-count="'+prevAsset+'"]')) {
					document.querySelector('[data-previmage]').disabled = false;
					document.querySelector('[data-previmage]').dataset.previmage = document.querySelector('.gallery__grid-item[data-count="'+prevAsset+'"]').getAttribute('data-id');
				} else {
					document.querySelector('[data-previmage]').disabled = true;
				}

				if(document.querySelector('.gallery__grid-item[data-count="'+nextAsset+'"]')) {
					document.querySelector('[data-nextimage]').disabled = false;
					document.querySelector('[data-nextimage]').dataset.nextimage = document.querySelector('.gallery__grid-item[data-count="'+nextAsset+'"]').getAttribute('data-id');
				} else {
					document.querySelector('[data-nextimage]').disabled = true;
				}
			}
		})

		document.querySelector('.part-gallery-lightbox .caption').innerHTML = assetToLoad.getAttribute('data-caption');

        document.querySelector('.part-gallery-lightbox .current').innerHTML = assetToLoad.getAttribute('data-count');
        document.querySelector('.part-gallery-lightbox .lightbox__content').appendChild(assetToLoad.firstElementChild.cloneNode(true));
		document.querySelector('.part-gallery-lightbox .lightbox__content').firstElementChild.classList.add('visible');

        this.htmlVideos = document.querySelectorAll('.video--html');
        this.htmlVideos && this.htmlVideos.forEach((video)=>
        {
            let options =
                {
                    autoplay: false,
                    loop: true,
                    muted: false,
                    controls: true,
                    cover: false,
                    click: true,
                }
            if( video.classList.contains('video--autoplay') ){
                options.autoplay = true;
                options.controls = false;
                options.muted 	 = true;
            }
            if( video.classList.contains('video--cover') ){
                options.cover = true;
            }
            new HtmlVideoPlayer(video, options);
        })

		let pageURL = new URL(window.location.href);
		if(imageID) {
			pageURL.searchParams.set('media', imageID);
			window.history.pushState({}, '', pageURL);
		}
    }
}